import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { CalendarClock } from 'lucide-react'
import { apiURL } from '../utilities/URLs'
import { account } from '../classes/Account'
import { refreshAccessToken } from '../utilities/extensions'

export default function PaymentInstallmentsBanner ({ applicationId: propApplicationId }) {
  const navigate = useNavigate()
  const location = useLocation()
  const [showOffer, setShowOffer] = useState(false)
  const applicationId = propApplicationId || extractApplicationIdFromPath(location.pathname)

  useEffect(() => {
    if (!applicationId) return
    if (location.pathname.includes('/payment-installments')) return

    const checkOffer = async () => {
      try {
        const res = await fetch(`${apiURL}/api/applications/${applicationId}/payment-installments`, {
          headers: { Authorization: account.accessToken }
        })
        const data = await res.json()
        if (data.response?.error === 'Failed To Authenticate Token.') {
          const refreshed = await refreshAccessToken()
          if (refreshed && refreshed.length > 0) return checkOffer()
          return
        }
        setShowOffer(Boolean(data.response?.offerEligible))
      } catch (error) {
        console.error('Payment installment offer check failed:', error)
      }
    }

    checkOffer()
  }, [applicationId, location.pathname])

  if (!showOffer || !applicationId) return null

  return (
    <div className='w-full flex items-center justify-between bg-sky-50 dark:bg-sky-900/20 shadow-sm border-b border-sky-200 dark:border-sky-600/30 px-6 py-3 transition-colors duration-300 z-50'>
      <div className='flex items-center gap-3'>
        <div className='flex items-center justify-center bg-sky-600 text-white rounded-full w-8 h-8 shadow-sm'>
          <CalendarClock size={16} />
        </div>
        <div className='flex flex-col'>
          <span className='text-xs font-bold text-sky-900 dark:text-sky-300 uppercase tracking-wider'>Payment installments available</span>
          <span className='text-sm font-medium text-sky-800 dark:text-sky-400'>You can now split an unpaid invoice into weekly or monthly payments.</span>
        </div>
      </div>
      <button
        type='button'
        onClick={() => navigate(`/applications/${applicationId}/payment-installments`)}
        className='flex items-center gap-2 px-4 py-1.5 bg-sky-900/10 hover:bg-sky-900/20 dark:bg-sky-500/10 dark:hover:bg-sky-500/20 text-sky-900 dark:text-sky-300 rounded-xl text-sm font-semibold transition-all duration-200 active:scale-95 border border-sky-900/10 dark:border-sky-500/20 whitespace-nowrap cursor-pointer'
      >
        Set up now
      </button>
    </div>
  )
}

function extractApplicationIdFromPath (pathname) {
  const match = pathname.match(/\/applications\/([^/]+)/)
  return match ? match[1] : ''
}
